import RegisterCompanyPage from "./RegisterCompanyPage";

export default RegisterCompanyPage;
